import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { Button, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useSaveDraftRoomVersionMutation } from 'src/features/manage-room/manage-room.slice';
import { StyledButtonIcon, StyledButtonText } from '../publish-modal/publish-modal.styles';
import { StyledEmptyStateContainer, StyledEmptyStateDescription, StyledEmptyStateHeading } from './empty-state.styles';
export const VersionControlEmptyState = ({
  roomCode
}: {
  roomCode?: string;
}) => {
  const [saveDraftRoomVersion, {
    isLoading
  }] = useSaveDraftRoomVersionMutation();
  const handleCreateFirstDraft = async () => {
    if (!roomCode) {
      NotificationDispatch('error', 'Unable to create draft: Room code is missing');
      return;
    }
    try {
      await saveDraftRoomVersion({
        roomCode
      }).unwrap();
      NotificationDispatch('success', 'First draft version has been created successfully');
    } catch {
      NotificationDispatch('error', 'Failed to create draft version. Please try again.');
    }
  };
  return <StyledEmptyStateContainer data-sentry-element="StyledEmptyStateContainer" data-sentry-component="VersionControlEmptyState" data-sentry-source-file="empty-state.tsx">
      <StyledEmptyStateHeading data-sentry-element="StyledEmptyStateHeading" data-sentry-source-file="empty-state.tsx">This room has no versions yet</StyledEmptyStateHeading>
      <StyledEmptyStateDescription data-sentry-element="StyledEmptyStateDescription" data-sentry-source-file="empty-state.tsx">Create your first draft version to get started</StyledEmptyStateDescription>

      <Button variant="solid" color="add"
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onClick={handleCreateFirstDraft} isLoading={isLoading} style={{
      marginTop: '2rem'
    }} data-sentry-element="Button" data-sentry-source-file="empty-state.tsx">
        <StyledButtonIcon icon={faCirclePlus} data-sentry-element="StyledButtonIcon" data-sentry-source-file="empty-state.tsx" />
        <StyledButtonText data-sentry-element="StyledButtonText" data-sentry-source-file="empty-state.tsx">Create First Draft</StyledButtonText>
      </Button>
    </StyledEmptyStateContainer>;
};